import Switch from "common/components/ui/Switch";

export default function BooleanFilter({
  label,
  isChecked,
  onCheckedChange,
  isDisabled = false,
}: {
  label: string;
  isChecked: boolean;
  onCheckedChange: (isChecked: boolean) => void;
  isDisabled?: boolean;
}) {
  return (
    <div className="mx-2 flex items-center gap-x-1 border-b border-b-black-200 px-1.5 py-1.75 last:border-none">
      <span className="text-button-xs mr-auto">{label}</span>

      <Switch
        size="sm"
        checked={isChecked}
        onCheckedChange={onCheckedChange}
        disabled={isDisabled}
      />
    </div>
  );
}
